import { IQueryContext } from 'framework/context/IQueryContext';
import { IPurchase, IPurchasesQueryMetadata, IPurchasesQueryParams, IQueryResultWithMetadata } from 'gen/ApiClient';
import React from 'react';

export const PurchasesQueryContext = React.createContext<IQueryContext<IQueryResultWithMetadata<IPurchase, IPurchasesQueryMetadata>, IPurchasesQueryParams>>(
	undefined as any
);
